module.exports = __webpack_public_path__ + "img/neoncityday.29e11f78.gif";